/**
 * Return card title based on card type
 * @param {string} cardBrand Selected card
 * @param {string} cardNameFallback Card name fallback
 * @returns {string}
 */
export default function getCardTitle(cardBrand, cardNameFallback = '') {
	let cardName;
	if (['amex', 'american-express', 'americanexpress'].includes(cardBrand)) {
		cardName = 'American Express';
	} else if (['mastercard', 'master-card'].includes(cardBrand)) {
		cardName = 'Mastercard';
	} else if (cardBrand === 'visa') {
		cardName = 'Visa';
	} else if (cardBrand === 'dinersclub') {
		cardName = 'Diners Club';
	} else if (cardBrand === 'discover') {
		cardName = 'Discover';
	} else if (cardBrand === 'jcb') {
		cardName = 'JCB';
	} else if (cardBrand === 'unionpay') {
		cardName = 'UnionPay';
	} else if (cardBrand === 'bancontact_card') {
		cardName = 'Bancontact';
	} else if (cardBrand === 'elo') {
		cardName = 'Elo';
	} else if (cardBrand === 'hipercard') {
		cardName = 'Hipercard';
	} else {
		cardName = cardNameFallback;
	}
	return cardName;
}
